import React, { createContext, useState } from "react";

export const ForwardFittingContext = createContext();

export const ForwardFittingProvider = (props) => {
  const remotefittinginitialdata = {
    swingdata: {
        swing1: "",
        swing2: "",
        status: false
    },
    irondata: {
        whiteiron: {
            name: "White Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        blackiron: {
            name: "Black Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        blueiron: {
            name: "Blue Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        pinkiron: {
            name: "Pink Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        purpleiron: {
            name: "Purple Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        rediron: {
            name: "Red Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        orangeiron: {
            name: "Orange Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        greeniron: {
            name: "Green Irons",
            location: "",
            iron1: {
                cameraimage: ""
            },
            iron2: {
                cameraimage: ""
            },
            iron3: {
                cameraimage: ""
            },
            preferred_club: ""
        },
        status: false
    },
    balldata: {
        type: "link",
        value: "google.com",
        status: false
    },
    notes: {
        notes: ""
    }
}
;

  const [remotefittingdata, setRemotefittingdata] = useState(
    remotefittinginitialdata
  );

  const updateremotefitting = (path, value, id) => {
    setRemotefittingdata((prevState) => {
      // Creating a deep copy of the state
      let newData = JSON.parse(JSON.stringify(prevState));
      // let newData = prevState;
      // Splitting the path and reducing it to find the nested object
      path.split(".").reduce((o, k, i, keys) => {
        if (i === keys.length - 1) {
          var dataidkey = k + "_value";
          o[k] = value; // Updating the value at the specific path
          // o[dataidkey] = id;
        }
        return o[k];
      }, newData);
      console.log("amineshji newData", newData);
      return newData;
    });
  };

  return (
    <ForwardFittingContext.Provider
      value={{
        remotefittingdata,
        setRemotefittingdata,
        updateremotefitting,
      }}
    >
      {props.children}
    </ForwardFittingContext.Provider>
  );
};
